import React, { useEffect, useRef, useState } from "react";
import "./Indicators.scss";

const stats = [
    { value: 7, suffix: "", label: "Years Building Products" },
    { value: 12, suffix: "", label: "Clients Served" },
    { value: 14, suffix: "", label: "Projects Delivered" },
];

const Indicators = () => {
    const sectionRef = useRef(null);
    const [counts, setCounts] = useState(() => stats.map((stat) => stat.value));

    useEffect(() => {
        const section = sectionRef.current;
        const motionPreference = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        );

        if (
            !section ||
            motionPreference.matches ||
            !("IntersectionObserver" in window)
        ) {
            return;
        }

        let animationFrame;
        let started = false;
        let cancelled = false;

        const showFinalValues = () => {
            window.cancelAnimationFrame(animationFrame);
            setCounts(stats.map((stat) => stat.value));
        };

        const animate = () => {
            const duration = 1400;
            let startTime;

            const update = (time) => {
                if (cancelled) return;

                if (startTime === undefined) startTime = time;

                const progress = Math.min((time - startTime) / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3);

                setCounts(
                    stats.map((stat) => Math.round(stat.value * easedProgress))
                );

                if (progress < 1) {
                    animationFrame = window.requestAnimationFrame(update);
                }
            };

            animationFrame = window.requestAnimationFrame(update);
        };

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting || started || cancelled) return;

                started = true;
                observer.disconnect();

                if (motionPreference.matches) {
                    showFinalValues();
                    return;
                }

                setCounts(stats.map(() => 0));
                animate();
            },
            { threshold: 0.25 }
        );

        const handleMotionChange = (event) => {
            if (event.matches) {
                observer.disconnect();
                showFinalValues();
            }
        };

        observer.observe(section);
        motionPreference.addEventListener("change", handleMotionChange);

        return () => {
            cancelled = true;
            observer.disconnect();
            window.cancelAnimationFrame(animationFrame);
            motionPreference.removeEventListener("change", handleMotionChange);
        };
    }, []);

    return (
        <section
            className="indicators"
            id="track-record"
            ref={sectionRef}
            aria-labelledby="indicators-title"
        >
            <div className="indicators__inner">
                <div className="indicators__header">
                    <p className="indicators__eyebrow">Our Track Record</p>

                    <h2 id="indicators-title">
                        Experience in <span>Numbers.</span>
                    </h2>

                    <p className="indicators__intro">
                        Years of building products, working with clients, and delivering
                        digital projects.
                    </p>
                </div>

                <dl className="indicators__stats">
                    {stats.map((stat, index) => (
                        <div className="indicators__stat" key={stat.label}>
                            <dt className="indicators__label">{stat.label}</dt>

                            <dd className="indicators__value">
                <span aria-hidden="true">
                  {counts[index]}
                    {stat.suffix}
                </span>

                                <span className="indicators__sr-only">
                  {stat.value}
                                    {stat.suffix}
                </span>
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
        </section>
    );
};

export default Indicators;